import Seo from '../components/Seo';
import DeconstructedDish from '../components/DeconstructedDish';
import { TORTILLA_DECONSTRUCTED } from '../data/dishes';
import { Link } from 'react-router-dom';
import { waLink } from '../lib/contact';
import { breadcrumb } from '../lib/seo-schemas';

const WA_TORTILLA = waLink('Hola Bar Cabrero! Hay tortilla hoy?');

export default function Tortilla() {
  return (
    <>
      <Seo
        title="Tortilla casera del Cabrero"
        description="Tortilla española casera del Bar Cabrero (Torrelavega). Patata cántabra del Valle del Pas, huevo fresco de granja local, virgen extra de Jaén y cebolla blanca. Hecha cada mañana."
        path="/tortilla"
        schemas={[breadcrumb([{ name: 'Tortilla casera', path: '/tortilla' }])]}
      />

      <section className="sec sec-surf" data-testid="tortilla-page">
        <div className="split col2">
          <div>
            <p className="eyebrow rv">Hecha en casa cada mañana</p>
            <h1 className="D D-xl rv" style={{ marginBottom: '1.25rem' }}>
              Tortilla <em>casera.</em>
            </h1>
            <p className="lead rv" style={{ marginBottom: '1rem' }}>
              Patata cántabra del Valle del Pas, cortada a mano. Huevo fresco de granja local. Virgen extra de Jaén. Cebolla blanca pochada hasta el dorado.
            </p>
            <p className="copy rv">
              Sin atajos. Nada precocinado. Cada mañana, antes de abrir, montamos la del día. <strong>Cuando se acaba, se acaba.</strong>
            </p>
            <div className="rv" style={{ display: 'flex', gap: '0.85rem', flexWrap: 'wrap', marginTop: '1.75rem' }}>
              <Link to="/visitanos" className="btn btn-g" data-testid="tortilla-cta-visitanos">Ven a probarla →</Link>
              <a className="btn btn-o" href={WA_TORTILLA} target="_blank" rel="noopener noreferrer" data-testid="tortilla-cta-wa">¿Hay tortilla hoy?</a>
            </div>
          </div>
          <div className="rv">
            <img
              src="/dishes/tortilla.jpg"
              alt="Tortilla española casera del Bar Cabrero — patata, huevo, aceite y cebolla"
              style={{ width: '100%', aspectRatio: '4/3', objectFit: 'cover', borderRadius: 'var(--r)' }}
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* DECONSTRUIDA */}
      <DeconstructedDish config={TORTILLA_DECONSTRUCTED} />

      {/* SECRETOS / FILOSOFÍA */}
      <section className="sec sec-surf" data-testid="tortilla-philosophy">
        <p className="eyebrow rv" style={{ textAlign: 'center' }}>Sin atajos</p>
        <h2 className="D D-md rv" style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          Cuatro <em>verdades</em> sobre nuestra tortilla.
        </h2>
        <div className="split col2">
          <div className="rv">
            <div className="fcard">
              <h4>Patata cortada a mano</h4>
              <p>Mandolina y cuchillo. Láminas finas pero no tan finas que se rompan al pochar. La textura empieza aquí.</p>
            </div>
            <div className="fcard">
              <h4>Pochada lenta</h4>
              <p>Aceite a fuego suave durante 30–40 minutos. La patata no se fríe — se confita. Es el truco.</p>
            </div>
          </div>
          <div className="rv">
            <div className="fcard">
              <h4>Huevo del día</h4>
              <p>Fresco, batido a mano. Yema naranja. Mezcla con la patata caliente para que se "lije" un poco.</p>
            </div>
            <div className="fcard">
              <h4>Cuajado al gusto</h4>
              <p>En el Cabrero, jugosita por dentro. La sirves con pan y un blanco bien frío. Felicidad simple.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
